import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-gettenant',
    templateUrl: './gettenant.component.html',
    styleUrls: ['./gettenant.component.scss'],
    standalone: false
})
export class GettenantComponent implements OnInit{

  chooseTenant: Boolean;
  RouterSegments: RouterSegments;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private authService: AuthService,
    private sidenavService: SidenavService) {}

  ngOnInit(): void {
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.chooseTenant = tenantId ? false : true;
    if (tenantId) {
      // localStorage.setItem('tenantDashboardTenantId', tenantId);
      this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, tenantId, 'dashboard']);
      this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.DASHBOARD';
    } else {
      // localStorage.setItem('tenantDashboardTenantId', '');
    }
  }

}
